module.exports = __webpack_public_path__ + "static/media/footer_gif_govo240.3a1abae4.gif";